import {isAuthorized, isEntitled} from '@nursio-link/common/authorization';

import {useGroups} from '@/hooks/useAuth';
import {useEntitlements} from '@/hooks/useEntitlements';

import type {ExportListId} from '../types/exportTypes';
import {exportRegistry} from '../utils/exportRegistry';

export const useExportDefinitions = () => {
  const groups = useGroups();
  const entitlements = useEntitlements();

  if (!groups || !entitlements) return [];

  return exportRegistry.filter(
    ({permission, entitlement}) =>
      isAuthorized(groups, permission) &&
      (!entitlement || isEntitled(entitlements, entitlement))
  );
};

export const useCanExport = (list: ExportListId) =>
  useExportDefinitions().some(({id}) => id === list);
